import React from "react";


export function Error(){

    
    return(

        <div className="container-fluid">
            
            <div className="row bg-light min-h-100 d-flex align-items-center">
                {/* ------------------------------------ */}
                <div className="col-lg-12"> 
                    <div className="row d-flex justify-content-center">
                        <div className="col-md-6 justify-content-center d-flex align-items-center">
                            <div className="d-flex flex-column align-items-center justify-content-center"> 
                                <div className="d-flex align-items-center mb-4">
                                    <span className="font-lg color-light ps-3 pe-1 py-1 rounded-start-1 bg-green border border-success" > SAMA </span>
                                    <span className="font-lg color-green border ps-1 pe-3 py-1 rounded-end-1" > DOC </span>
                                </div>
                                <div className="d-flex px-5 py-3 justify-content-center border border-success bg-green-light shadow-sm rounded-3">
                                    <span className="color-green text-center display-2 px-5"> PAGE 404 </span> 
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>

    )
}

